"use strict";

define('rs/paginate',['vertebrae'], function (Vertebrae) {
  var Paginate = Vertebrae.Object.extend({
    properties: ['page', 'totalPages', 'totalItems', 'totalPageItems', 'resetProperties', 'size', 'sort', 'filters', 'sortDirection', 'query'],
    initialize: function initialize(properties) {
      var resetProperties = _.extend({}, this.defaults(), properties);
      this.setFilters({});
      this.setResetProperties(resetProperties);
      this.applyProperties(resetProperties);
      this._super.apply(this, arguments);
      this.listenTo(this, 'change:totalPages', function () {
        if (this.getTotalPages() < this.getPage()) {
          this.setPage(this.getTotalPages());
        }
      });
    },
    importProperties: function importProperties(properties) {
      _.each(properties, function (value, key) {
        if (this.hasSetter(key)) {
          this.setter(key, value);
        } else {
          _.chain(String(value).split(',')).map(decodeURIComponent).each(function (v) {
            this.addFilter(key, v);
          }, this);
        }
      }, this);
      return this;
    },
    defaults: function defaults() {
      return {
        firstPage: 1,
        page: 1,
        size: 25,
        sort: null,
        filter: null,
        totalPages: 0,
        sortDirection: 'asc',
        query: null
      };
    },
    getFilterByName: function getFilterByName(key) {
      return [].concat(this.getFilters()[key] || []);
    },
    hasFilter: function hasFilter(key) {
      return this.getFilterByName(key).length > 0;
    },
    hasFilterValue: function hasFilterValue(key, value) {
      return _.contains(this.getFilterByName(key), value);
    },
    addFilter: function addFilter(key, value) {
      var filters = this.getFilters(),
        filterKey = filters[key];
      if (!_.isArray(filterKey)) {
        filterKey = filters[key] = [];
      }
      if (!_.contains(filterKey, value)) {
        filterKey.push(value);
      }
      this.trigger('change:filters:' + key, true);
      this.trigger('change:filters');
      return this;
    },
    removeFilter: function removeFilter(key, value) {
      var filters = this.getFilters(),
        filterKey = filters[key];
      if (arguments.length > 1) {
        var index = _.indexOf(filterKey, value);
        if (index >= 0) {
          filterKey.splice(index, 1);
        }
        if (_.isEmpty(filterKey)) {
          delete filters[key];
        }
      } else {
        if (filterKey) {
          delete filters[key];
        }
      }
      this.trigger('change:filters:' + key, false);
      this.trigger('change:filters');
      return this;
    },
    setPage: function setPage() {
      return this._super.apply(this, arguments);
    },
    next: function next() {
      if (!this.isLastPage()) {
        var currentPage = this.getPage() || 0;
        this.setPage(currentPage + 1);
        this.trigger('next');
      }
      return this;
    },
    previous: function previous() {
      var currentPage = this.getPage() || 0;
      this.setPage(Math.max(currentPage - 1, this.firstPage));
      this.trigger('previous');
      return this;
    },
    isLastPage: function isLastPage() {
      if (!this.getTotalPages()) {
        return true;
      }
      if (this.getPage() == this.getTotalPages()) {
        return true;
      }
      return false;
    },
    itemRange: function itemRange() {
      var size = this.getSize(),
        page = this.getPage() || this.firstPage,
        subtract = this.firstPage - 0,
        startIndex = size * Math.max(page - subtract, 0);
      return [startIndex + 1, startIndex + (this.getTotalPageItems() || 0)];
    },
    resetPage: function resetPage() {
      this.setPage(this.firstPage);
      return this;
    },
    reset: function reset() {
      this.applyProperties(this.getResetProperties());
      return this;
    },
    toggleDirection: function toggleDirection() {
      if (this.getSortDirection() == 'asc') {
        this.setSortDirection('desc');
      } else {
        this.setSortDirection('asc');
      }
      return this;
    },
    serializeFilters: function serializeFilters(options) {
      var params = {},
        processFn = null;
      options = _.extend({
        encode: false
      }, options);
      if (options.encode) {
        processFn = encodeURIComponent;
      }
      _.each(this.getFilters(), function (filter, key) {
        if (!_.isEmpty(filter) && !params[key]) {
          if (_.isFunction(processFn)) {
            filter = _.map(filter, processFn);
          }
          params[key] = filter.join(',');
        }
      });
      return params;
    },
    routeParams: function routeParams() {
      var params = {};
      _.each(['page', 'query', 'sort', 'sortDirection', 'size'], function (k) {
        var value = this.getter(k);
        if (value) {
          params[k] = value;
        }
      }, this);
      return _.extend({}, this.serializeFilters({
        encode: false
      }), params);
    },
    params: function params() {
      var params = {
        page: this.getPage(),
        size: this.getSize(),
        'sort.dir': this.getSortDirection()
      };
      if (this.getSort()) {
        params.sort = this.getSort();
      }
      if (this.getQuery()) {
        params.q = this.getQuery();
      }
      return _.extend({}, this.serializeFilters({
        encode: false
      }), params);
    }
  });
  return Paginate;
});

